<template>
    <div style="height: 100%; overflow: auto">
        <b-card class="sa-card" header="Farmacie" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Codice Struttura:</label>
                    <b-form-select v-model="jsonData.codiceStruttura">
                        <b-form-select-option :value="null"> -Seleziona Struttura- </b-form-select-option>
                        <b-form-select-option v-for="struttura in strutturaOptions" :key="struttura.codiceStruttura" :value="struttura.codiceStruttura">{{ struttura.denominazione }} ({{ struttura.codiceStruttura }}) </b-form-select-option>
                    </b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Farmacia:</label>
                    <b-form-input v-model="jsonData.farmacia"></b-form-input>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Provincia:</label>
                    <b-form-select v-model="provincia" :options="provincieOptions" @change="onChangeProvinciaResidenza"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Comune:</label>
                    <b-form-select v-model="jsonData.comune" :options="comuniOptions" @change="onChangeComune" value-field="codiceIstat" text-field="comune"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Cap:</label>
                    <b-form-input v-model="jsonData.cap"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Frazione:</label>
                    <b-form-input v-model="jsonData.frazione"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Indirizzo:</label>
                    <b-form-input v-model="jsonData.via"></b-form-input>
                </b-col>
                <!-- <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Id Agenda:</label>
                    <b-form-input v-model="jsonData.idAgenda"></b-form-input>
                </b-col> -->
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Titolare:</label>
                    <b-form-input v-model="jsonData.titolare"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Partita IVA:</label>
                    <b-form-input v-model="jsonData.partitaIva"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Telefono:</label>
                    <b-form-input v-model="jsonData.telefono"></b-form-input>
                </b-col>

                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Email:</label>
                    <b-form-input v-model="jsonData.email"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import StruttureMixin from "../../mixins/StruttureMixin";

export default {
    mixins: [UtilityMixin, StruttureMixin],
    data() {
        return {
            pathResource: "/farmacie",
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",
            pathResourceComuniByCodiceIstat: "/comuni/istat",
            jsonData: {
                farmacia: null,
                cap: null,
                codiceStruttura: null,
                comune: null,
                frazione: null,
                idAgenda: null,
                partitaIva: null,
                telefono: null,
                via: null,
                titolare: null,
                email: null,
            },
            provincia: null,
            provincieOptions: [],
            comuniOptions: [],
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        strutturaOptions: {
            handler(strutture) {
                let me = this;

                me.codiciStrutturaOptions = [{ value: null, text: "-Seleziona Struttura-" }];

                if (strutture && strutture.length > 0) {
                    strutture.forEach((struttura) => {
                        me.codiciStrutturaOptions.push({
                            value: struttura.codiceStruttura,
                            text: struttura.codiceStruttura + " - " + struttura.denominazione,
                        });
                    });
                }
            },
            deep: true,
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.comuniOptions = [{ codiceIstat: null, comune: "-Seleziona Comune-" }];
        me.loadProvincieOptions();
        me.struttureLoadData();
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            if (me.id === "-1") {
                this.$emit("afterLoadData");
            } else {
                UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
            }
        },
        loadDataSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            if (me.id !== "-1" && me.jsonData.comune) {
                me.loadComuneByIstat(me.jsonData.comune);
            }
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            me.$emit("afterLoadData");
            console.log("Errore nel caricamento dei dati", error);
        },
        loadProvincieOptions() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/province";
            axios
                .get(link)
                .then((response) => {
                    me.provincieOptions = [];
                    response.data.data.forEach((element) => {
                        me.provincieOptions.push({
                            value: element.sigla,
                            text: element.provincia,
                        });
                    });
                    me.provincieOptions.unshift({ value: null, text: "-Seleziona Provincia-" });
                    me.comuniOptions = [{ codiceIstat: null, comune: "-Seleziona Comune-" }];
                })
                .catch((error) => {
                    console.log("Errore nel caricamento delle province: " + error.response.status);
                });
        },
        onChangeProvinciaResidenza(provincia) {
            let me = this;
            me.jsonData.comune = null;
            me.comuniOptions = [{ codiceIstat: null, comune: "-Seleziona Comune-" }];
            if (provincia) {
                me.loadComuni(provincia);
            }
        },
        loadComuni(sigla) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuni + "/" + sigla;
            axios
                .get(link)
                .then((response) => {
                    me.comuniOptions = response.data.data;
                    me.comuniOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
                })
                .catch((error) => {
                    console.log("Errore nel caricamento dei comuni", error);
                });
        },
        loadComuneByIstat(codiceIstat) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuniByCodiceIstat + "/" + codiceIstat;
            axios
                .get(link)
                .then((response) => {
                    me.comuniOptions = response.data.data;
                    me.comuniOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
                })
                .catch((error) => {
                    console.log("Errore nel caricamento del comune da ISTAT", error);
                });
        },
        onChangeComune() {
            let me = this;
            me.comuniOptions.forEach((element) => {
                if (element.codiceIstat === me.jsonData.comune) {
                    me.jsonData.cap = element.cap;
                }
            });
        },
    },
};
</script>
